import { render, staticRenderFns } from "./Proteccion.vue?vue&type=template&id=c01bedb4&"
import script from "./Proteccion.vue?vue&type=script&lang=ts&"
export * from "./Proteccion.vue?vue&type=script&lang=ts&"
import style0 from "./Proteccion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports